import { DocumentosState } from "../../types/state.types";
import { StoreAction } from "../reduxTypes";
import * as actions from "./actions";

const initialState: DocumentosState = {
  dadosArquivos: [],
  loading: false,
};

const reducer = (
  state: DocumentosState = initialState,
  action: StoreAction
): DocumentosState => {
  switch (action.type) {
    case actions.DOCUMENTOS__SET_DADOS_ARQUIVOS:
      return {
        ...state,
        dadosArquivos: action.payload,
      };

    case actions.DOCUMENTOS__SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case "SESSION__LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default reducer;
